import styled from "styled-components"

export const StyledGlobalDateDropdown = styled.div`
    position: relative;
`
